import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  inject,
} from '@angular/core';

import { Button } from 'primeng/button';
import { ConfirmationService, Icon, IconComponent } from '@web/shared/ui';
import { Tooltip } from 'primeng/tooltip';
import { PublicCartService } from '../../services/public-cart.service';
import { Guid } from '@web/utils';

@Component({
  selector: 'app-public-cart-remove-button',
  imports: [Button, IconComponent, Tooltip],
  templateUrl: './public-cart-remove-button.component.html',
  styleUrl: './public-cart-remove-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicCartRemoveButtonComponent {
  private readonly cart = inject(PublicCartService);
  private readonly confirmation = inject(ConfirmationService);

  public readonly productId = input.required<Guid>();
  public readonly removeSuccessEvent = output<void>();

  protected readonly Icon = Icon;

  public handleRemoveClick(): void {
    this.confirmation.show((builder) =>
      builder
        .title('Potwierdzenie usunięcia')
        .message('Czy na pewno chcesz usunąć wybrany produkt z koszyka?')
        .accept(() =>
          this.cart.removeItem(this.productId()).subscribe(() => {
            this.removeSuccessEvent.emit();
          }),
        )
        .build(),
    );
  }
}
